import axios from "axios";
import { customStyles, HOST_URL } from "../../helpers/constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  LAUNCH_VIEWER,
  MODEL_FILTER_STATE,
  SELECTED_MODELS,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import {
  ARCHIVED_MARKUPS,
  CREATED_BY_LIST,
  CREATED_FOR_LIST,
  FILTERED_MARKUPS,
  MARKUPS_LOADING,
  PROJECT_MARKUP_DATA,
  updateMarkupState,
} from "../../helpers/reducers/MarkupReducer";
import { Form } from "react-bootstrap";

const FolderFilters = ({ updateMarkupData }) => {
  const { selectedProject, allDocs, cloudFiles, regionalStatuses } =
    useSelector((state) => state.globalReducer);
  const { modelFilterState } = useSelector((state) => state.modelReducer);

  const [filteredDocs, setFilteredDocs] = useState([]);
  const [processAreaOptions, setProcessAreaOptions] = useState([]);
  const [disciplineOptions, setDisciplineOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  const statusOptions = ["Everything", "WIP", "SHARED", "PUBLISHED"]; //this need changing to show S0 etc?

  useEffect(() => {
    const processAreasTemp = [];

    const tempAllDocs = allDocs.filter((o) => o.status !== "Retired");

    tempAllDocs.forEach((doc) => {
      if (
        !processAreasTemp.map((o) => o.processArea).includes(doc.mwhAssetName)
      ) {
        processAreasTemp.push({
          processArea: doc.mwhAssetName,
          projectAssetId: doc.projectAssetId,
        });
      }
    });

    const tempData = tempAllDocs
      .filter((doc) => {
        if (doc.mwhAssetName) {
          return doc.mwhAssetName;
        }
      })
      .map((doc) => doc.mwhAssetName);
    const uniqueArray = tempData.filter(function (item, pos) {
      return tempData.indexOf(item) === pos;
    });
    setProcessAreaOptions([
      {
        processArea: "Everything",
        projectAssetId: null,
      },
      ...processAreasTemp,
    ]);

    const tempData2 = tempAllDocs
      .filter((doc) => {
        if (doc.discipline) {
          return doc.discipline;
        }
      })
      .map((doc) => doc.discipline);
    const uniqueArray2 = tempData2.filter(function (item, pos) {
      return tempData2.indexOf(item) === pos;
    });
    setDisciplineOptions(["Everything", ...uniqueArray2]);

    if (tempAllDocs.length > 0) {
      setFilteredDocs([...tempAllDocs]);
    }
  }, [allDocs]);

  const filter = (value, type) => {
    const tempProcessFilter =
      type === "processArea"
        ? value.processArea
        : (modelFilterState.process?.processArea ?? "Everything");
    const tempStatusFilter =
      type === "status" ? value : (modelFilterState.status ?? "Everything");
    const tempDisciplineFilter =
      type === "discipline"
        ? value
        : (modelFilterState.discipline ?? "Everything");

    let tempDocs = [...filteredDocs];
    if (tempProcessFilter) {
      if (tempProcessFilter !== "Everything")
        tempDocs = tempDocs.filter((doc) => {
          return doc.mwhAssetName?.includes(tempProcessFilter);
        });
    }
    // Always treat tempProcessFilter as an array (even if single value)
    // const processAreas = tempProcessFilter && tempProcessFilter !== "Everything"
    //   ? Array.isArray(tempProcessFilter)
    //   ? tempProcessFilter
    //   : [tempProcessFilter]
    //   : null;
    // if (processAreas) {
    //   tempDocs = tempDocs.filter((doc) =>
    //   processAreas.some((area) => doc.processArea?.includes(area))
    //   );
    // }
    if (tempStatusFilter) {
      const sharedStatuses = [];
      const publishedStatuses = [];
      regionalStatuses.forEach((s) => {
        if (s.published) {
          publishedStatuses.push(s.code);
        } else {
          sharedStatuses.push(s.code);
        }
      });
      if (tempStatusFilter !== "Everything")
        if (tempStatusFilter === "WIP") {
          tempDocs = tempDocs.filter((doc) => {
            return doc.status?.includes("S0");
          });
        } else if (tempStatusFilter === "SHARED") {
          tempDocs = tempDocs.filter((doc) => {
            return sharedStatuses?.includes(doc.status);
            // return doc.revision?.includes("P") && !doc.revision?.includes(".");
          });
        } else if (tempStatusFilter === "PUBLISHED") {
          tempDocs = tempDocs.filter((doc) => {
            return publishedStatuses?.includes(doc.status);
            // return doc.revision?.includes("C") && !doc.revision?.includes(".");
          });
        }
    }
    if (tempDisciplineFilter) {
      if (tempDisciplineFilter !== "Everything")
        tempDocs = tempDocs.filter((doc) => {
          return doc.discipline?.includes(tempDisciplineFilter);
        });
    }
    const filteredModels = cloudFiles?.filter((item) =>
      tempDocs
        .map((x) => x.docNumber + ".rvt") //add nwd here to pull federated models
        .includes(item.attributes.displayName),
    );
    const furtherFilteredModels = filteredModels?.map((model) => {
      const mviewData = tempDocs.find(
        (o) => o.docNumber + ".rvt" === model.attributes.name, //add nwd here to pull federated models
      );
      //update doc description here.
      //add an if statement to the update description function to only do it if the model.attributes.versionNumber is less than or equal to 2??

      // updateDescription(
      //   selectedProject[0].id,
      //   model.relationships.item.data.id,
      //   mviewData.task
      // );
      return {
        id: model.relationships.derivatives.data.id,
        documentName: model.attributes.name,
        storageLocation: model.relationships.storage.meta.link.href,
        task: mviewData.task,
        status: mviewData.status,
        sharedRevision: mviewData.sharedRevision,
        publishedRevision: mviewData.publishedRevision,
        projectAssetTaskId: mviewData.id,
        selectedVersion: mviewData.versions.find((v) => v.current === true)?.id, //ToDo Robert - This is a temporary fix, need to find a better way to get the selected version
        asset: mviewData.processArea,
        versions: mviewData.versions,
        visible: true,
        discipline: mviewData.discipline,
        mwhAssetName: mviewData.mwhAssetName,
        lastUpdated: mviewData.lastUpdated,
      };
    });

    const tempModelFilters = { ...modelFilterState };
    switch (type) {
      case "processArea":
        tempModelFilters.process = value;
        break;
      case "status":
        tempModelFilters.status = value;
        break;
      case "discipline":
        tempModelFilters.discipline = value;
        break;
      default:
        break;
    }
    if (tempModelFilters.process) fetchMarkups(tempModelFilters.process);
    dispatch(
      updateModelState({
        value: tempModelFilters,
        stateName: MODEL_FILTER_STATE,
      }),
    );
    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateModelState({
        value: furtherFilteredModels,
        stateName: SELECTED_MODELS,
      }),
    );
  };

  const updateDescription = async (accId, itemId, description) => {
    const tempData = {
      accId,
      itemId,
      description,
    };

    let formData = new FormData();
    formData.append("formData", JSON.stringify(tempData));

    axios({
      method: "post",
      url: HOST_URL + "/forgedata/updateModelDescription",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then((response) => {
        // alert(response.data.message); // do we need this?
        // debugger;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sortArray = (arr, fieldToSort) => {
    let tempField = fieldToSort.toString();
    return arr.sort((a, b) => a[tempField] - b[tempField]);
  };

  const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  };

  const fetchMarkups = (projectAsset) => {
    dispatch(
      updateMarkupState({
        value: true,
        stateName: MARKUPS_LOADING,
      }),
    );
    const projectId = selectedProject[0].id;
    // let formData = new URLSearchParams();
    // let formData = new FormData();

    // formData.append(
    //   "formData",
    //   JSON.stringify({
    //     projectId: projectId,
    //     projectAsset: projectAsset?.processArea,
    //   }),
    // );

    axios({
      method: "get",
      url: HOST_URL + "/markups/getMarkups",
      params: { projectId: projectId, projectAsset: projectAsset?.processArea },
      withCredentials: true,
    })
      .then((response) => {
        dispatch(
          updateMarkupState({
            value: response.data,
            stateName: PROJECT_MARKUP_DATA,
          }),
        );
        // updateMarkupData(response);
        let tempFilteredMarkups = { data: [] };
        let tempArchivedMarkups = { data: [] };
        response.data.forEach((markup) => {
          if (markup.archived) {
            tempArchivedMarkups.data.push(markup);
          } else {
            tempFilteredMarkups.data.push(markup);
          }
        });
        tempFilteredMarkups.data = sortArray(tempFilteredMarkups.data, "id");
        dispatch(
          updateMarkupState({
            value: tempFilteredMarkups,
            stateName: FILTERED_MARKUPS,
          }),
        );
        dispatch(
          updateMarkupState({
            value: tempArchivedMarkups,
            stateName: ARCHIVED_MARKUPS,
          }),
        );
        dispatch(
          updateMarkupState({
            value: false,
            stateName: MARKUPS_LOADING,
          }),
        );
        const tempCreatedBy = tempFilteredMarkups.data.map((markup) => {
          return markup.userName;
        });

        if (tempCreatedBy) {
          const uniqueCreatedBy = removeDuplicates(tempCreatedBy);
          dispatch(
            updateMarkupState({
              value: uniqueCreatedBy,
              stateName: CREATED_BY_LIST,
            }),
          );
        }

        const tempMarkups = tempFilteredMarkups.data.filter((markup) => {
          if (markup.createdFor) {
            return markup.createdFor;
          }
        });
        const tempCreatedFor = [];
        tempMarkups.forEach((markup) => {
          if (typeof markup.createdFor === "string") {
            tempCreatedFor.push(markup.createdFor);
          } else {
            tempCreatedFor.push(...markup.createdFor);
          }
        });
        if (tempCreatedFor) {
          const uniqueCreatedFor = removeDuplicates(tempCreatedFor);
          dispatch(
            updateMarkupState({
              value: uniqueCreatedFor,
              stateName: CREATED_FOR_LIST,
            }),
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const customStyles = {
  //   control: (provided, state) => ({
  //     ...provided,
  //     background: "#fff",
  //     borderColor: "#9e9e9e",
  //     minHeight: "30px",
  //     height: "30px",
  //     boxShadow: state.isFocused ? null : null,
  //   }),

  //   option: (styles) => {
  //     const color = "rgb(0, 0, 0)";
  //     // const color2 = "rgba(0, 0, 0, 0.3)";
  //     return {
  //       ...styles,
  //       color: color,
  //     };
  //   },

  //   valueContainer: (provided, state) => ({
  //     ...provided,
  //     height: "30px",
  //     padding: "0 6px",
  //   }),

  //   input: (provided, state) => ({
  //     ...provided,
  //     margin: "0px",
  //   }),
  //   indicatorSeparator: (state) => ({
  //     display: "none",
  //   }),
  //   indicatorsContainer: (provided, state) => ({
  //     ...provided,
  //     height: "30px",
  //   }),
  // };

  const onCloseModal = () => {
    setModalOpen(false);
  };

  const filterStyles = {
    ...customStyles,
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
      fontSize: "12px",
    }),
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      background:
        "linear-gradient(120deg, rgba(58,58,58,0.34) 0%, rgba(0,93,133,0.42) 100%)",
      borderColor: state.isFocused
        ? "rgba(147,213,0,0.72)"
        : "rgba(242,242,242,0.34)",
      minHeight: "34px",
      height: "34px",
      borderRadius: "999px",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)"
        : "0 8px 18px rgba(58,58,58,0.2)",
      "&:hover": {
        borderColor: "rgba(147,213,0,0.72)",
        boxShadow:
          "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.7)",
    }),
    input: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "rgba(242,242,242,0.95)",
      background: state.isSelected
        ? "linear-gradient(120deg, rgba(147,213,0,0.42), rgba(156,197,202,0.28))"
        : state.isFocused
          ? "linear-gradient(120deg, rgba(147,213,0,0.26), rgba(156,197,202,0.2))"
          : "rgba(0,0,0,0)",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      border: "1px solid rgba(242,242,242,0.24)",
      background:
        "linear-gradient(165deg, rgba(58,58,58,0.96) 0%, rgba(0,93,133,0.92) 100%)",
      boxShadow: "0 14px 28px rgba(58,58,58,0.28)",
      overflow: "hidden",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgba(156,197,202,0.95)",
    }),
  };

  return (
    <>
      <div className="folderFiltersContainer">
        <h5>
          3D Model Filters
          {/* <button
            type="button"
            className="btn mwh-btn-primary rounded-circle btn-sm"
            style={{
              width: "25px",
              height: "25px",
              fontSize: "10px",
              paddingTop: 0,
              paddingBottom: 0,
              position: "relative",
              top: -10,
            }}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <i className="fa-solid fa-info"></i>
          </button> */}
        </h5>
        {selectedProject && cloudFiles.length > 0 && (
          <div className="bs-component" style={{ textAlign: "center" }}>
            <div className="row" style={{ paddingBottom: "10px" }}>
              <div
                className="col-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "14px" }}>Asset</label>
              </div>
              <div className="col" style={{ paddingRight: "24px" }}>
                <Select
                  className="basic-single"
                  placeholder="Please select an asset to filter with"
                  menuPortalTarget={document.body}
                  options={processAreaOptions?.map((asset) => {
                    return {
                      value: asset.processArea,
                      label: asset.processArea,
                      completeObj: asset,
                    };
                  })}
                  styles={filterStyles}
                  isSearchable={true}
                  onChange={(e) => {
                    filter(e.completeObj, "processArea");
                  }}
                  value={{
                    value: modelFilterState.process?.processArea,
                    label: modelFilterState.process?.processArea,
                    completeObj: modelFilterState.process,
                  }}
                  isDisabled={!selectedProject}
                />
              </div>
            </div>
            <div className="row" style={{ paddingBottom: "10px" }}>
              <div
                className="col-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "14px" }}>Status</label>
              </div>
              <div className="col" style={{ paddingRight: "24px" }}>
                <Select
                  className="basic-single"
                  placeholder="Please select an asset to add"
                  menuPortalTarget={document.body}
                  options={statusOptions?.map((status) => {
                    return { value: status, label: status };
                  })}
                  onChange={(e) => {
                    filter(e.value, "status");
                  }}
                  styles={filterStyles}
                  value={{
                    value: modelFilterState.status,
                    label: modelFilterState.status,
                  }}
                  isDisabled={!selectedProject}
                />
              </div>
            </div>
            <div className="row" style={{ paddingBottom: "10px" }}>
              <div
                className="col-3 "
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "14px" }}>Discipline</label>
              </div>
              <div className="col" style={{ paddingRight: "24px" }}>
                <Select
                  className="basic-single"
                  placeholder="Please select an asset to add"
                  menuPortalTarget={document.body}
                  options={disciplineOptions?.map((discipline) => {
                    return { value: discipline, label: discipline };
                  })}
                  styles={filterStyles}
                  isSearchable={true}
                  onChange={(e) => {
                    filter(e.value, "discipline");
                  }}
                  value={{
                    value: modelFilterState.discipline,
                    label: modelFilterState.discipline,
                  }}
                  isDisabled={!selectedProject}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {/* MODALS */}
      {/* <Modal
        show={modalOpen}
        onHide={onCloseModal}
        dialogClassName="markup-modal bg-dark"
        center="true"
        fullscreen={true}
      >
        <Modal.Header className="bg-dark text-white">
          <Modal.Title>Model Browser Page Information</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={onCloseModal}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="bg-dark text-white rounded">
          <video
            className="browser-info-video"
            src={modelBrowser}
            autoPlay
            loop
          />
        </Modal.Body>
      </Modal> */}
    </>
  );
};

//
export default React.memo(FolderFilters);
